import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, Transition as _Transition } from "vue"

import { computed, watch } from "vue";
import HeaderMainComponent from "@/components/HeaderMain.component.vue";
import { useStore } from "vuex";
import { RootState } from "@/types/state.type";
import SidebarSupportComponent from "@/components/sidebar/SidebarSupportComponent.vue";
import SidebarStationsComponent from "@/components/sidebar/SidebarStationsComponent.vue";
import SidebarAdminComponent from "@/components/sidebar/SidebarAdminComponent.vue";
import SidebarSaceComponent from "../sidebar/SidebarSaceComponent.vue";
import SidebarIssueMonitoringComponent from "../sidebar/SidebarIssueMonitoringComponent.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  sidebar: String,
},
  setup(__props) {

const props = __props

const store = useStore<RootState>();

// - list of sidebars
const sidebars: { [key: string]: unknown } = {
  SidebarAdmin: SidebarAdminComponent,
  SidebarSupport: SidebarSupportComponent,
  SidebarStations: SidebarStationsComponent,
  SidebarSace: SidebarSaceComponent,
  SidebarIssueMonitoring: SidebarIssueMonitoringComponent,
};

// - props


// - computed
const sidebarComponent = computed(() =>
  props.sidebar && sidebars[props.sidebar] ? sidebars[props.sidebar] : null
);
const sidebarOpen = computed(() => sidebarComponent.value && store.state.ui.sidebarOpen);

// - watch
watch(
  () => store.state.ui.sidebarOpen,
  () => {
    // - fire resize event (delay )
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 500);
  }
);

// - methods
/**
 * sidebar Toggle
 */
const sidebarToggle = (force: undefined | boolean = undefined) => {
  store.commit("ui/sidebarToggle", force);
};

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, {
    direction: "vertical",
    class: "wrapper-layout"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "header" }, {
        default: _withCtx(() => [
          _createVNode(HeaderMainComponent)
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, { class: "wrapper-main" }, {
        default: _withCtx(() => [
          (_unref(sidebarComponent))
            ? (_openBlock(), _createBlock(_component_el_aside, {
                key: 0,
                class: "aside"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(sidebarComponent))))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_main, { class: "main app-main-scroll" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_unref(sidebarOpen))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarToggle())),
                class: "hidden-lg-and-up el-overlay"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 3
  }))
}
}

})